
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.366 7.706l1.07-.082 6.67.247v.576s0 .082-.165.082-5.929-.164-5.929-.164l-.74-.494-.906-.083c0 .083-.083.165-.083.165-.165.247-.494.247-.74.165l-.577 1.07-3.541 5.682-.494-.33s-.082-.082 0-.247C1.013 14.13 4.06 9.27 4.06 9.27L4.8 8.86l.494-.741a.5.5 0 010-.66l.165-.164-.494-.906-3.13-6.01.495-.248s.082 0 .164.165 2.8 5.27 2.8 5.27l-.082.906.411.823c.165 0 .33 0 .412.082.247.083.33.165.33.33z"}})])
          )
        }
      }
    